import { BaseActionWithNav } from "./BaseActionWithNav";
import { boundingExtent } from "ol/extent";
import { Switchboard } from "../../lib/events";
import { Popup } from "../interactions/popup/Popup";
class ResultTable {
    constructor(columns, data) {
        this.strapToDataMap = new Map();
        this.columns = columns;
        this.data = data;
        const strapIndex = this.strap_index;
        if (strapIndex !== -1) {
            data.forEach(row => {
                const strapValue = row[strapIndex];
                this.strapToDataMap.set(strapValue, row);
            });
        }
    }
    get strap_index() {
        const col = this.columns.find(c => c.displayName.toLowerCase() === "strap");
        return col ? parseInt(col.name) : -1;
    }
    get ids() {
        const strapIndex = this.strap_index;
        if (strapIndex === -1)
            return [];
        return this.data.map(row => row[strapIndex]);
    }
    get_data_for(strap) {
        let schema = {};
        this.columns.filter(c => c.visible).forEach(col => schema[col.displayName] = null);
        const row = this.strapToDataMap.get(strap);
        if (!row)
            return schema;
        for (const col of Object.keys(schema)) {
            const column = this.columns.find(c => c.displayName === col);
            if (column.name !== null) {
                schema[col] = row[parseInt(column.name)];
            }
        }
        return schema;
    }
}
var pinnedTooltips = [];
export class AnalyzeSalesRatioAction extends BaseActionWithNav {
    constructor(map, layer) {
        super('SET SALES');
        this.map = map;
        this.layer = layer;
        this.emitter = Switchboard.get_emitter("CONTEXT");
        this.handleTooltipAndPinDisplay = (event) => {
            if (event.dragging)
                return;
            Popup.removeUnpinnedTooltips(event, pinnedTooltips);
            const pixel = this.map.getEventPixel(event.originalEvent);
            let features = this.map.get_features_at_pixel(pixel);
            let r_features = features.filter(v => v[1] === this.layer.raw).map(v => v[0]);
            if (r_features.length === 0)
                return;
            const f = r_features[0];
            var data = f.getProperties();
            if (data) {
                var columns = ['Date', 'Price', 'Val', 'S/R'];
                var filteredData = columns.reduce((result, column) => {
                    if (data.hasOwnProperty(column)) {
                        result[column] = data[column];
                    }
                    return result;
                }, {});
                const popup = new Popup(f, this.map);
                popup.addOrUpdateOverlay(filteredData);
                const pinButton = popup.setupPinButton(filteredData);
                if (!pinButton.data('listenerAdded')) {
                    pinButton.on('click', () => {
                        pinnedTooltips = popup.handlePinButtonClick(pinButton, filteredData, pinnedTooltips);
                    });
                    pinButton.data('listenerAdded', true);
                }
            }
        };
    }
    validate(message) {
        return super.validate(message) && typeof message.table === 'string' && message.table.length > 0;
    }
    on_valid_message() { this.emitter.emit('ctx_request', 'set'); }
    async interpret(message) {
        const resultObj = JSON.parse(message.table);
        const resultTable = new ResultTable(resultObj.columns, resultObj.data);
        let ids = resultTable.ids;
        let allTooltips = $('[id*=tooltip-]');
        allTooltips.each(function () {
            if (!ids.find(id => `tooltip-${id}` == this.id)) {
                $(this).hide();
                pinnedTooltips = [];
            }
        });
        this.layer.clear();
        if (ids.length === 0)
            return;
        await this.layer.add_features_by_ids(ids);
        this.zoom_to_extent();
        for (let parcel of this.layer.features) {
            const strap = parcel.get(this.layer.identifier);
            const record = resultTable.get_data_for(strap);
            for (let key in record)
                parcel.set(key, record[key]);
        }
        this.layer.style_manager.update_style('default', message.mode);
        if (this.layer.colorized) {
            this.layer.colorize_current_parcels();
            this.layer.color_manager.populate_legend();
        }
        this.map.on('pointermove', evt => {
            this.handleTooltipAndPinDisplay(evt);
        });
    }
    zoom_to_extent() {
        let extent;
        if (this.layer.features.length === 1) {
            extent = this.layer.features[0].getGeometry().getExtent();
        }
        else {
            extent = boundingExtent(this.layer.features.map(f => f.getGeometry().getExtent()));
        }
        const padding = [150, 120, 150, 120];
        const mapSize = this.map.getSize();
        const view = this.map.getView();
        const [minX, minY, maxX, maxY] = extent;
        const adjustedExtent = [
            minX - padding[3],
            minY - padding[2],
            maxX + padding[1],
            maxY + padding[0]
        ];
        view.fit(adjustedExtent, { size: mapSize, padding, duration: 200 });
    }
}
